export const CATEGORY_BELOW_THE_FOLD_CONTAINER_ID = 'category-below-the-fold-text';
